import {invalidateQueries, q} from "../../state";
import {
  CreateDisclosureChecklistModel,
  CreatedDisclosureChecklistTemplate,
  DisclosureChecklistModel,
  DisclosureChecklistModelId,
  DisclosureChecklistTemplate,
  DisclosureChecklistTemplateId,
  PresetDisclosureChecklistTemplate,
} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(): Promise<DisclosureChecklistModel[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/disclosure_checklist_models", {});
}

export async function get(modelId: DisclosureChecklistModelId): Promise<DisclosureChecklistModel> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/disclosure_checklist_models/{disclosure_checklist_model_id}",
    {path: {disclosure_checklist_model_id: modelId}},
  );
}

export async function create(model: CreateDisclosureChecklistModel): Promise<DisclosureChecklistModelId> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/disclosure_checklist_models", {
    body: model,
  });
  await invalidateQueries([q.tprm.disclosureChecklistModels.filter()]);
  return res;
}

export async function getTemplate(
  modelId: DisclosureChecklistModelId,
  templateId: DisclosureChecklistTemplateId,
): Promise<DisclosureChecklistTemplate> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/disclosure_checklist_models/{disclosure_checklist_model_id}/templates/{disclosure_checklist_template_id}",
    {path: {disclosure_checklist_model_id: modelId, disclosure_checklist_template_id: templateId}},
  );
}

export async function createTemplateFromPreset(
  modelId: DisclosureChecklistModelId,
  preset: PresetDisclosureChecklistTemplate,
): Promise<CreatedDisclosureChecklistTemplate> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/disclosure_checklist_models/{disclosure_checklist_model_id}/templates/create_from_preset",
    {path: {disclosure_checklist_model_id: modelId}, body: preset},
  );
  await invalidateQueries([
    q.tprm.disclosureChecklistModels.filter(),
    q.tprm.disclosureChecklistModel.filter(),
    q.tprm.questionnaireModels.filter(),
  ]);
  return res;
}
